import * as mobiscroll$002Ereact$002Emin from "@mobiscroll/react/dist/css/mobiscroll.react.min.css";
import { setOptions as setOptions_1, Datepicker, localeNo } from "@mobiscroll/react";
import { class_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import * as react from "react";


export const Mobiscroll_localeNo = localeNo;

export class Mobiscroll_inputOption {
    constructor() {
    }
}

export function Mobiscroll_inputOption_$reflection() {
    return class_type("Feliz.Mobiscroll.Mobiscroll.inputOption", undefined, Mobiscroll_inputOption);
}

export function Mobiscroll_inputOptions(opts) {
    return keyValueList(opts, 1);
}

export class Mobiscroll_globalOption {
    constructor() {
    }
}

export function Mobiscroll_globalOption_$reflection() {
    return class_type("Feliz.Mobiscroll.Mobiscroll.globalOption", undefined, Mobiscroll_globalOption);
}

export class Mobiscroll_datePicker {
    constructor() {
    }
}

export function Mobiscroll_datePicker_$reflection() {
    return class_type("Feliz.Mobiscroll.Mobiscroll.datePicker", undefined, Mobiscroll_datePicker);
}

export function Mbs_DatePicker(props) {
    const props_1 = keyValueList(props, 1);
    return react.createElement(Datepicker, props_1);
}

/**
 * Takes a list of options and applies them to the global scope.
 */
export function Mbs_setGlobalOptions(props) {
    const setOptions = setOptions_1;
    setOptions(keyValueList(props, 1));
}

//# sourceMappingURL=Feliz.Mobiscroll.js.map
